module.exports = __webpack_public_path__ + "img/protection.32539080.svg";